import { Grid, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import "./transaction.type.select.css";

interface ITransactionTypeSelect {
    value?: string | null;
    title: string;
    width?: string;
    updateStatus: (arg?: string | null) => void;
}

const TransactionTypeSelect: FC<ITransactionTypeSelect> = (props: ITransactionTypeSelect) => {
    const { t } = useTranslation();
    const selectOptions = [
        { id: null, text: t("general.All") },
        { id: "Loading", text: t("transaction.Loading") },
        { id: "Usage", text: t("transaction.Usage") },
        { id: "BalanceReset", text: t("transaction.BalanceReset") },
        { id: "Freeze", text: t("transaction.Freeze") },
        { id: "CancelFreeze", text: t("transaction.CancelFreeze") },
        { id: "Refund", text: t("transaction.Refund") },
        { id: "UpdExpireDate", text: t("transaction.UpdExpireDate") },
    ];
    return (
        <Grid>
            <InputLabel id="select-transaction-status-label">{props.title}</InputLabel>
            <Select
                id="transaction-select-status"
                labelId="select-transaction-status-label"
                className="transaction-select-status"
                label={props.title}
                sx={{ width: props.width ?? "100%" }}
                onChange={(e: SelectChangeEvent) => {
                    if (e.target.value) {
                        const option = selectOptions.find(({ text }) => text === e.target.value);
                        if (option) props.updateStatus(option.id);
                    }
                }}
                value={selectOptions.find(({ id }) => id === props.value)?.text}
            >
                {selectOptions.map(({ text }) => (
                    <MenuItem key={text} value={text}>
                        {text}
                    </MenuItem>
                ))}
            </Select>
        </Grid>
    );
};

export default TransactionTypeSelect;
